<q-mission-calculateur
                       [client]="actionCoService.Model.Customer.Id"
                       [idActionCo]="actionCoService.Model.idActionCo"
                       [typeDevis]="actionCoService.Model.TypeDevis"
                       [status]="actionCoService.Model.Status"
                       [isCloture]="actionCoService.Model.IsCloture"
                       (mission)="ListenMission()"
                       (save)="OnSave()">

</q-mission-calculateur>
